import { useState } from 'react';
import { api } from '../api';
import { Auftragswahl, Auftragszeile, type Auftragskopf } from '../bausteine/Auftragswahl';
import { Fehler } from '../bausteine/Meldung';
import { heute } from '../format';
import { navigiere } from '../router';

/**
 * Ein Rapport beginnt mit einem Auftrag – und einem Tag.
 *
 * **Zwei Schritte, nicht einer.** Vorher legte der Griff auf die Karte den
 * Rapport sofort an. Ein Fehlgriff auf dem Telefon war dann ein Rapport mit
 * verbrauchter Nummer, den man nur noch stornieren konnte (Regel 6: keine
 * Nummer wird wiederverwendet). Jetzt steht der gewählte Auftrag erst
 * einmal da, mit dem Datum daneben, und erst „Rapport anlegen" verbraucht
 * die Nummer.
 */
export function Neu() {
  const [gewaehlt, setGewaehlt] = useState<Auftragskopf | null>(null);
  const [datum, setDatum] = useState(heute());
  const [fehler, setFehler] = useState<unknown>(null);
  const [laeuft, setLaeuft] = useState(false);

  const anlegen = async () => {
    if (!gewaehlt) return;

    setLaeuft(true);
    setFehler(null);

    try {
      const r = await api.legeAn({
        auftragId: gewaehlt.id,
        datum,
        einsatzort: '',
        ansprechpartner: '',
        taetigkeit: '',
        bemerkung: '',
        positionen: [],
      });

      navigiere(`/rapport/${r.id}/bearbeiten`);
    } catch (f) {
      setFehler(f);
      setLaeuft(false);
    }
  };

  if (gewaehlt) {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void anlegen();
        }}
      >
        <h1 className="mb-1 text-2xl font-semibold">Neuer Rapport</h1>
        <p className="mb-4 text-slate-600">Zu diesem Auftrag, an diesem Tag.</p>

        <Fehler fehler={fehler} />

        <div className="karte">
          <Auftragszeile auftrag={gewaehlt} />
        </div>

        <div className="karte mt-3">
          <label className="feldname" htmlFor="datum">
            Datum
          </label>
          <input
            id="datum"
            type="date"
            required
            className="feld sm:max-w-xs"
            value={datum}
            onChange={(e) => setDatum(e.target.value)}
          />
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          <button type="submit" className="knopf-haupt" disabled={laeuft}>
            Rapport anlegen
          </button>
          <button
            type="button"
            className="knopf"
            disabled={laeuft}
            onClick={() => setGewaehlt(null)}
          >
            Anderen Auftrag wählen
          </button>
        </div>
      </form>
    );
  }

  return (
    <>
      <h1 className="mb-1 text-2xl font-semibold">Neuer Rapport</h1>
      <p className="mb-4 text-slate-600">Zu welchem Auftrag? Nur offene Aufträge aus dem ERP.</p>

      <Auftragswahl autoFocus onWahl={setGewaehlt} />
    </>
  );
}
